import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faEarthAmericas } from "@fortawesome/pro-duotone-svg-icons/faEarthAmericas";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const OnlineClassesFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(!!filters["program_environment"]?.includes("ONLINE"));

  return filterSettings?.environment.includes("ONLINE") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Online classes",
            filterGroup: "program_environment",
            filterItem: "ONLINE",
            filters,
          });
        }
        return setFilters(({ program_environment, ...prevFilters }) => ({
          ...prevFilters,
          program_environment: isActive ? [] : ["ONLINE"],
        }));
      }}
      isActive={isActive}
      title="Online classes"
      iconProps={{
        icon: faEarthAmericas,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-online-classes"
    />
  ) : null;
};

export const FilterPill = ({
  onClick,
  isActive,
  title,
  iconProps,
}: {
  onClick: () => void;
  isActive: boolean;
  title: string;
  iconProps: FontAwesomeIconProps;
}) => (
  <StyledFilterPill
    onClick={onClick}
    isActive={isActive}
    color={iconProps.color}
    data-testid="dream-search-filter-online-classes"
  >
    <FontAwesomeIcon size="2x" {...iconProps} />
    <Typography
      variant="subtitle1"
      // Decorative pill label, not a section heading — `subtitle1` would otherwise render an <h6>.
      component="span"
      sx={{ mt: 1, color: isActive ? "text.primary" : "#04299E90" }}
      fontWeight={700}
    >
      {title}
    </Typography>
  </StyledFilterPill>
);

const StyledFilterPill = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isActive" && prop !== "color",
})<{
  color: string | undefined;
  isActive: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;
  color: ${({ color }) => color};
  border-bottom: ${({ isActive }) => (isActive ? `2px solid` : "none")};
`;
